import { render, staticRenderFns } from "./VideoAnnotations.vue?vue&type=template&id=5252f9bd&scoped=true"
import script from "./VideoAnnotations.vue?vue&type=script&lang=js"
export * from "./VideoAnnotations.vue?vue&type=script&lang=js"
import style0 from "./VideoAnnotations.vue?vue&type=style&index=0&id=5252f9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252f9bd",
  null
  
)

export default component.exports